import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SafeHtmlPipe } from 'src/app/core/pipes/safe-html.pipe';

import { VgApiService } from '@videogular/ngx-videogular/core';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';
import { ManagementUser } from 'src/app/core/models/management-user.model';

/**
 * This HtmlResourceComponent represents a Resource asset that itself is HTML and should be
 * rendered in the app. Other resource assets are external files that are loaded via
 * link in a new browser window. Because these should be viewed in app, we need a component to
 * render them.
 */
@Component({
    selector: 'wf-html-resource',
    templateUrl: './html.component.html',
    styleUrls: ['./html.component.css'],
    standalone: false
})
export class HtmlResourcesComponent implements OnInit {
  resourceContent: string = '' ;
  viewResourceVideo: boolean = false ;
  playerAPI: VgApiService;
  videoToLoad = null;
  videoSource: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public vgApiService: VgApiService,
    private sessionStorageService: SessionStorageService
  ) {
    this.playerAPI = vgApiService ;
  }

  ngOnInit(): void {
    this.resourceContent = this.route.snapshot.data['resolveData']['content'] ;
    this.videoSource = this.route.snapshot.data['resolveData']['videoUrl'] ;
    if (this.videoSource) this.viewResourceVideo = true ;
  }

  onPlayerReady(API: VgApiService) {
    this.playerAPI = API;
    this.playerAPI.getDefaultMedia().subscriptions.ended.subscribe({
      next: () => { this.onCompleteVideo(); }
    });
  }

  onCompleteVideo(){
    this.playerAPI.pause();
    this.playerAPI.currentTime = 0;
    this.viewResourceVideo = false;
  }

  setVideo(video: any){
    this.videoSource = "/assets/resources/" + video;
  }

  playVideo(video: any) {
    if (this.playerAPI != null) {
      this.viewResourceVideo = true;
      this.setVideo(video);
      this.playerAPI.play();
    }
  }

  handleContentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchorElement = target.closest('a');

    if (anchorElement && anchorElement.hasAttribute('href')) {
      const href = anchorElement.getAttribute('href')!;

      // Check for internal Angular routes.
      if (href.startsWith('/#/')) {
        event.preventDefault();

        if (href.indexOf('students') > -1) {
          this.handleStudentListClick();
        }

        const angularRoute = href.substring(2);
        this.router.navigateByUrl(angularRoute)
          .catch(err => console.error(`Failed to navigate to ${angularRoute}`, err));
      } else if (href.startsWith('/') && !href.startsWith('//') &&
                 !href.startsWith('mailto:') && !href.startsWith('tel:') &&
                 !href.startsWith('http:') && !href.startsWith('https:')) {

        event.preventDefault();
        this.router.navigateByUrl(href)
          .catch(err => console.error(`Failed to navigate to ${href}`, err));
      }
    }
  }

  handleStudentListClick(): void {
    let currentUser: ManagementUser | null = this.sessionStorageService.getUserData();
    
    if (currentUser !== null && currentUser.isTeacherUser()) {
      this.router.navigateByUrl('/students');
    } else {
      this.router.navigateByUrl('/students/list');
    }
  }

  replayVideo(){
    this.playVideo(this.videoToLoad)
  };
}
